export default "https://assets.egbcdn.net/assets/packs/_/images/net-logo-32845b70f8e536f83b79ed673e631850.svg";